import { render, staticRenderFns } from "./ScreenColumn.vue?vue&type=template&id=155465ec&scoped=true&"
import script from "./ScreenColumn.vue?vue&type=script&lang=js&"
export * from "./ScreenColumn.vue?vue&type=script&lang=js&"
import style0 from "./ScreenColumn.vue?vue&type=style&index=0&id=155465ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155465ec",
  null
  
)

export default component.exports